import { cn } from "@/lib/utils";
import { splitTrailingMark } from "../utils/formChrome";

interface FormInstrumentTitleProps {
    /** Short line above the name. */
    caption?: string | null;
    /** Patient-facing title. */
    name?: string | null;
    /** Short line under the name. */
    kicker?: string | null;
    /** Cover is the public start page. Page is the smaller title repeated on each question. */
    variant?: "cover" | "page";
    /** From forms.title_align. Centre lines up every line of the title block. */
    align?: "left" | "center";
    className?: string;
}

const lineClass = "font-medium text-muted-foreground text-lg tracking-wide";

/** Caption, then the form name, then the kicker. A blank field is not shown. */
export function FormInstrumentTitle({
    caption,
    name,
    kicker,
    variant = "cover",
    align = "left",
    className,
}: FormInstrumentTitleProps) {
    if (!caption && !name && !kicker) return null;

    const title = name ? splitTrailingMark(name) : null;
    const titleClass =
        variant === "cover" ? "font-bold text-lg" : "font-medium text-slate-500 dark:text-slate-400 text-lg";

    return (
        <div className={cn("flex flex-col gap-2 pb-2", align === "center" && "items-center text-center", className)}>
            {caption ? (
                <p data-anno="caption" className={lineClass}>
                    {caption}
                </p>
            ) : null}
            {name ? (
                <div data-title-source="name">
                    <h1 className={titleClass}>
                        {title?.text}
                        {title?.mark ? <sup>{title.mark}</sup> : null}
                    </h1>
                </div>
            ) : null}
            {kicker ? (
                <p data-anno="kicker" className={lineClass}>
                    {kicker}
                </p>
            ) : null}
        </div>
    );
}
